import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';
import { parseGroupTripJson } from './groupTripJson';

const snowflakeJson = { transformResponse: [parseGroupTripJson] };

export const groupTripApi = {
  listParties: (id) => travelClient.get(travelEndpoints.groupTripParties(id), snowflakeJson),
  listPartyAdditions: (id, party) => travelClient.get(travelEndpoints.partyAdditions(id, party), snowflakeJson),
  requestPartyAddition: (id, party, body) => travelClient.post(travelEndpoints.partyAdditions(id, party), body, snowflakeJson),
  decidePartyAddition: (id, party, request, action) => travelClient.post(travelEndpoints.partyAdditionAction(id, party, request, action), {}, snowflakeJson),

  create: (body) => travelClient.post(travelEndpoints.groupTrips, body, snowflakeJson),
  get: (groupTripId) => travelClient.get(travelEndpoints.groupTrip(groupTripId), snowflakeJson),
  updateDraft: (groupTripId, body) => travelClient.patch(
    travelEndpoints.groupTrip(groupTripId),
    body,
    snowflakeJson,
  ),
  open: (groupTripId, body) => travelClient.post(
    travelEndpoints.groupTripOpen(groupTripId),
    body,
    snowflakeJson,
  ),
  close: (groupTripId, body) => travelClient.post(
    travelEndpoints.groupTripClose(groupTripId),
    body,
    snowflakeJson,
  ),
  cancel: (groupTripId, body) => travelClient.post(
    travelEndpoints.groupTripCancel(groupTripId),
    body,
    snowflakeJson,
  ),
  listMine: (params) => travelClient.get(travelEndpoints.myGroupTrips, { ...snowflakeJson, params }),
  listApplications: (groupTripId) => travelClient.get(
    travelEndpoints.groupTripApplications(groupTripId),
    snowflakeJson,
  ),
  apply: (groupTripId, body) => travelClient.post(
    travelEndpoints.groupTripApplications(groupTripId),
    body || {},
    snowflakeJson,
  ),
  withdraw: (groupTripId, applicationId) => travelClient.post(
    travelEndpoints.groupTripApplicationWithdraw(groupTripId, applicationId),
    {},
    snowflakeJson,
  ),
  approve: (groupTripId, applicationId) => travelClient.post(
    travelEndpoints.groupTripApplicationApprove(groupTripId, applicationId),
    {},
    snowflakeJson,
  ),
  reject: (groupTripId, applicationId) => travelClient.post(
    travelEndpoints.groupTripApplicationReject(groupTripId, applicationId),
    {},
    snowflakeJson,
  ),
  listParticipants: (groupTripId) => travelClient.get(
    travelEndpoints.groupTripParticipants(groupTripId),
    snowflakeJson,
  ),
  getMyParticipant: (groupTripId) => travelClient.get(
    travelEndpoints.groupTripParticipantMe(groupTripId),
    snowflakeJson,
  ),
  withdrawParticipant: (groupTripId) => travelClient.post(
    travelEndpoints.groupTripParticipantWithdraw(groupTripId),
    {},
    snowflakeJson,
  ),
  removeParticipant: (groupTripId, participantId, body) => travelClient.post(
    travelEndpoints.groupTripParticipantRemove(groupTripId, participantId),
    body || {},
    snowflakeJson,
  ),
  listPublic: (params, config = {}) => travelClient.get(travelEndpoints.publicGroupTrips, {
    ...config,
    params,
    transformResponse: [
      ...(Array.isArray(config.transformResponse) ? config.transformResponse : []),
      parseGroupTripJson,
    ],
  }),
  getPublic: (groupTripId) => travelClient.get(
    travelEndpoints.publicGroupTrip(groupTripId),
    snowflakeJson,
  ),
  listTravelers: (groupTripId) => travelClient.get(
    travelEndpoints.groupTripTravelers(groupTripId),
    snowflakeJson,
  ),
  listBookings: (groupTripId) => travelClient.get(
    travelEndpoints.groupTripBookings(groupTripId),
    snowflakeJson,
  ),
  listDisruptionCases: (groupTripId) => travelClient.get(
    travelEndpoints.groupTripDisruptionCases(groupTripId),
    snowflakeJson,
  ),
  getDisruptionCase: (groupTripId, caseId) => travelClient.get(
    travelEndpoints.groupTripDisruptionCase(groupTripId, caseId),
    snowflakeJson,
  ),
  openDisruptionCase: (groupTripId, body, idempotencyKey) => travelClient.post(
    travelEndpoints.groupTripDisruptionCases(groupTripId), body,
    { ...snowflakeJson, headers: { 'Idempotency-Key': idempotencyKey } },
  ),
  assessDisruptionComponent: (groupTripId, caseId, componentId, body) => travelClient.post(
    travelEndpoints.groupTripDisruptionAssessment(groupTripId, caseId, componentId), body, snowflakeJson,
  ),
  requestDisruptionConfirmation: (groupTripId, caseId, componentId, body, idempotencyKey) => travelClient.post(
    travelEndpoints.groupTripDisruptionConfirmationRequest(groupTripId, caseId, componentId), body,
    { ...snowflakeJson, headers: { 'Idempotency-Key': idempotencyKey } },
  ),
  recordDisruptionConfirmation: (groupTripId, caseId, componentId, body, idempotencyKey) => travelClient.post(
    travelEndpoints.groupTripDisruptionConfirmation(groupTripId, caseId, componentId), body,
    { ...snowflakeJson, headers: { 'Idempotency-Key': idempotencyKey } },
  ),
  closeDisruptionCase: (groupTripId, caseId, body) => travelClient.post(
    travelEndpoints.groupTripDisruptionClose(groupTripId, caseId), body, snowflakeJson,
  ),
  issueTravelerClaim: (groupTripId, travelerId) => travelClient.post(
    travelEndpoints.groupTripTravelerClaim(groupTripId, travelerId),
    {},
    snowflakeJson,
  ),
  acceptTravelerClaim: (claimToken) => travelClient.post(
    travelEndpoints.groupTripTravelerClaimAccept,
    { claimToken },
    snowflakeJson,
  ),
  readRuntimeTimeline: (groupTripId) => travelClient.get(
    travelEndpoints.groupTripRuntimeTimeline(groupTripId),
    snowflakeJson,
  ),
  listRuntimeDecisions: (groupTripId) => travelClient.get(
    travelEndpoints.groupTripRuntimeDecisions(groupTripId),
    snowflakeJson,
  ),
  createRuntimeDecision: (groupTripId, body) => travelClient.post(
    travelEndpoints.groupTripRuntimeDecisions(groupTripId),
    body,
    snowflakeJson,
  ),
  voteRuntimeDecision: (groupTripId, decisionId, body) => travelClient.post(
    travelEndpoints.groupTripRuntimeDecisionVotes(groupTripId, decisionId),
    body,
    snowflakeJson,
  ),
  closeRuntimeDecision: (groupTripId, decisionId) => travelClient.post(
    travelEndpoints.groupTripRuntimeDecisionClose(groupTripId, decisionId),
    {},
    snowflakeJson,
  ),
  confirmRuntimeDecision: (groupTripId, decisionId) => travelClient.post(
    travelEndpoints.groupTripRuntimeDecisionConfirm(groupTripId, decisionId),
    {},
    snowflakeJson,
  ),
  listJourneyActivities: (groupTripId) => travelClient.get(
    travelEndpoints.groupTripJourneyActivities(groupTripId),
    snowflakeJson,
  ),
  readActivityParticipation: (groupTripId, journeyActivityId) => travelClient.get(
    travelEndpoints.groupTripActivityParticipation(groupTripId, journeyActivityId),
    snowflakeJson,
  ),
  readDisruption: (groupTripId) => travelClient.get(
    travelEndpoints.groupTripDisruption(groupTripId),
    snowflakeJson,
  ),
  startIndependentPeriod: (groupTripId, travelerId, body) => travelClient.post(
    travelEndpoints.groupTripIndependentPeriod(groupTripId, travelerId),
    body || {},
    snowflakeJson,
  ),
  endIndependentPeriod: (groupTripId, travelerId, periodId) => travelClient.post(
    travelEndpoints.groupTripIndependentPeriodEnd(groupTripId, travelerId, periodId),
    {},
    snowflakeJson,
  ),
  endGroupParticipation: (groupTripId, travelerId, body) => travelClient.post(
    travelEndpoints.groupTripParticipationEnd(groupTripId, travelerId),
    body || {},
    snowflakeJson,
  ),
  requestLateJoin: (groupTripId) => travelClient.post(
    travelEndpoints.groupTripLateJoinRequests(groupTripId),
    {},
    snowflakeJson,
  ),
  listMyLateJoinRequests: (groupTripId) => travelClient.get(
    travelEndpoints.groupTripLateJoinMine(groupTripId),
    snowflakeJson,
  ),
  listLateJoinRequests: (groupTripId, status) => travelClient.get(
    travelEndpoints.groupTripLateJoinRequests(groupTripId),
    { ...snowflakeJson, params: { status } },
  ),
  cancelLateJoinRequest: (groupTripId, requestId) => travelClient.post(
    travelEndpoints.groupTripLateJoinCancel(groupTripId, requestId),
    {},
    snowflakeJson,
  ),
  rejectLateJoinRequest: (groupTripId, requestId) => travelClient.post(
    travelEndpoints.groupTripLateJoinReject(groupTripId, requestId),
    {},
    snowflakeJson,
  ),
  approveLateJoinRequest: (groupTripId, requestId) => travelClient.post(
    travelEndpoints.groupTripLateJoinApprove(groupTripId, requestId),
    {},
    snowflakeJson,
  ),
  getGroupActual: (groupTripId) => travelClient.get(
    travelEndpoints.groupTripActual(groupTripId),
    snowflakeJson,
  ),
  getTravelerActual: (groupTripId, travelerId) => travelClient.get(
    travelEndpoints.groupTripTravelerActual(groupTripId, travelerId),
    snowflakeJson,
  ),
  // 只送後端請求欄位；建立者、擁有者與來源一律由後端依登入身分決定。
  createPersonalContinuation: (groupTripId, travelerId, { clientRequestId, continuationStartedAt, title }) => (
    travelClient.post(
      travelEndpoints.groupTripPersonalContinuations(groupTripId, travelerId),
      { clientRequestId, continuationStartedAt, title },
      snowflakeJson,
    )
  ),
  updateTravelerParticipation: (groupTripId, journeyActivityId, travelerId, body) => travelClient.put(
    travelEndpoints.groupTripTravelerParticipation(groupTripId, journeyActivityId, travelerId),
    body,
    snowflakeJson,
  ),
};
